import { useState } from 'react';
import PropTypes from 'prop-types';
import ChevronRight from '@mui/icons-material/ChevronRight';

function MessageForm({ onMessageSend, connected_yn: connectedYn }) {
  const [message, setMessage] = useState('');

  const onChange = event => {
    setMessage(event.target.value);
  };

  const handleFormSubmit = event => {
    event.preventDefault();
    if (message !== '' && connectedYn) {
      onMessageSend(message);
      setMessage('');
    }
  };

  return (
    <form
      className="message-form"
      name="newMessage"
      onSubmit={handleFormSubmit}
    >
      <div className="input-container">
        <input
          className="message-input"
          type="text"
          name="message"
          value={message}
          onChange={onChange}
        />
      </div>
      <div className="button-container">
        <ChevronRight
          className={
            connectedYn
              ? 'message-send-button'
              : 'message-send-button-loading'
          }
          onClick={handleFormSubmit}
          style={{
            color: '#fdfdfd',
          }}
        />
      </div>
    </form>
  );
}

MessageForm.propTypes = {
  onMessageSend: PropTypes.func.isRequired,
  connected_yn: PropTypes.bool.isRequired,
};
export default MessageForm;
